import {setPageMessage} from '../../actions/pageMessageActions';
import {stopOrderProcessing} from '../../actions/site-actions';
import Language from '../../lang/language';
import store from '../../store/store';

// Error callback function for the payment change order status poller
export default function paymentChangePollerFailed() {
  store.dispatch(setPageMessage(Language.getText('errors.updatePaymentDetailError')));

  store.dispatch(stopOrderProcessing());
}
